import { get, post } from "aws-amplify/api";
import { API_ENDPOINTS } from "./client";
import webStorage from "utils/webStorage";

export const getMeApi = async params => {
  try {
    const options = {
      queryParams: {
        ...params,
      },
    };

    const getMe = get({
      apiName: API_ENDPOINTS.AUTHENTICATED,
      path: "/reception/auth",
      options: options,
    });

    const { body } = await getMe.response;
    const response = await body.json();

    return response;
  } catch (e) {
    const error = await e?.response;
    if (error?.statusCode === 401 || error?.statusCode === 403) {
      webStorage.removeAll();
      window.replace.href = "/login";
    }
    throw error;
  }
};

export const LoginReceptionAdminApi = async (funeralId, password) => {
  try {
    const options = {
      body: {
        funeralId,
        password,
      },
    };

    return await post({
      apiName: API_ENDPOINTS.AUTHENTICATED,
      path: "/reception/login",
      options: options,
    })?.response;
  } catch (e) {
    const error = await e?.response;
    if (error?.statusCode === 401 || error?.statusCode === 403) {
      webStorage.removeAll();
      window.replace.href = "/login";
    }
    throw error;
  }
};
